export class obtenerIds {
  static idsCuentasP4(id: string, tipo: string){
    switch(tipo){
      case 'balance': 
        const idsBal = {
          '1':              [{nivel: 1, pos:1}],
          '101':              [{nivel: 2, pos:2}],
          '10101':              [{nivel: 3, pos:3}],
          '10102':              [{nivel: 3, pos:4}],
          '1010201':              [{nivel: 4, pos:5}],
          '1010202':              [{nivel: 4, pos:6}],
          '10103':              [{nivel: 3, pos:7}],
          '1010301':              [{nivel: 4, pos:8}],
          '1010302':              [{nivel: 4, pos:9}],
          '10104':              [{nivel: 3, pos:10}],
          '1010401':              [{nivel: 4, pos:11}],
          '1010402':              [{nivel: 4, pos:12}],
          '102':              [{nivel: 2, pos:13}],
          '10201':              [{nivel: 3, pos:14}],
          '1020101':              [{nivel: 4, pos:15}],
          '102010101':              [{nivel: 5, pos:16}],
          '102010102':              [{nivel: 5, pos:17}],
          '102010103':              [{nivel: 5, pos:18}],
          '1020102':              [{nivel: 4, pos:19}],
          '102010201':              [{nivel: 5, pos:20}],
          '102010202':              [{nivel: 5, pos:21}],
          '102010203':              [{nivel: 5, pos:22}],
          '10202':              [{nivel: 3, pos:23}],
          '1020201':              [{nivel: 4, pos:24}],
          '102020101':              [{nivel: 5, pos:25}],
          '102020102':              [{nivel: 5, pos:26}],
          '102020103':              [{nivel: 5, pos:27}],
          '1020202':              [{nivel: 4, pos:28}],
          '102020201':              [{nivel: 5, pos:29}],
          '102020202':              [{nivel: 5, pos:30}],
          '102020203':              [{nivel: 5, pos:31}],
          '10203':              [{nivel: 3, pos:32}],
          '1020301':              [{nivel: 4, pos:33}],
          '102030101':              [{nivel: 5, pos:34}],
          '102030102':              [{nivel: 5, pos:35}],
          '102030103':              [{nivel: 5, pos:36}],
          '1020302':              [{nivel: 4, pos:37}],
          '102030201':              [{nivel: 5, pos:38}],
          '102030202':              [{nivel: 5, pos:39}],
          '102030203':              [{nivel: 5, pos:40}],
          '103':              [{nivel: 2, pos:41}],
          '104':              [{nivel: 2, pos:42}],
          '10401':              [{nivel: 3, pos:43}],
          '1040101':              [{nivel: 4, pos:44}],
          '104010101':              [{nivel: 5, pos:45}],
          '104010102':              [{nivel: 5, pos:46}],
          '104010103':              [{nivel: 5, pos:47}],
          '104010104':              [{nivel: 5, pos:48}],
          '104010105':              [{nivel: 5, pos:49}],
          '104010106':              [{nivel: 5, pos:50}],
          '1040102':              [{nivel: 4, pos:51}],
          '104010201':              [{nivel: 5, pos:52}],
          '104010202':              [{nivel: 5, pos:53}],
          '104010203':              [{nivel: 5, pos:54}],
          '104010204':              [{nivel: 5, pos:55}],
          '104010205':              [{nivel: 5, pos:56}],
          '104010206':              [{nivel: 5, pos:57}],
          '104010207':              [{nivel: 5, pos:58}],
          '1040103':              [{nivel: 4, pos:59}],
          '104010301':              [{nivel: 5, pos:60}],
          '104010302':              [{nivel: 5, pos:61}],
          '10402':              [{nivel: 3, pos:62}],
          '1040201':              [{nivel: 4, pos:63}],
          '104020101':              [{nivel: 5, pos:64}],
          '104020102':              [{nivel: 5, pos:65}],
          '104020103':              [{nivel: 5, pos:66}],
          '104020104':              [{nivel: 5, pos:67}],
          '104020105':              [{nivel: 5, pos:68}],
          '104020106':              [{nivel: 5, pos:69}],
          '1040202':              [{nivel: 4, pos:70}],
          '104020201':              [{nivel: 5, pos:71}],
          '104020202':              [{nivel: 5, pos:72}],
          '104020203':              [{nivel: 5, pos:73}],
          '104020204':              [{nivel: 5, pos:74}],
          '104020205':              [{nivel: 5, pos:75}],
          '104020206':              [{nivel: 5, pos:76}],
          '104020207':              [{nivel: 5, pos:77}],
          '1040203':              [{nivel: 4, pos:78}],
          '104020301':              [{nivel: 5, pos:79}],
          '104020302':              [{nivel: 5, pos:80}],
          '10403':              [{nivel: 3, pos:81}],
          '1040301':              [{nivel: 4, pos:82}],
          '104030101':              [{nivel: 5, pos:83}],
          '104030102':              [{nivel: 5, pos:84}],
          '104030103':              [{nivel: 5, pos:85}],
          '1040302':              [{nivel: 4, pos:86}],
          '104030201':              [{nivel: 5, pos:87}],
          '104030202':              [{nivel: 5, pos:88}],
          '104030203':              [{nivel: 5, pos:89}],
          '104030204':              [{nivel: 5, pos:90}],
          '105':              [{nivel: 2, pos:91}],
          '10501':              [{nivel: 3, pos:92}],
          '1050101':              [{nivel: 4, pos:93}],
          '1050102':              [{nivel: 4, pos:94}],
          '1050103':              [{nivel: 4, pos:95}],
          '10502':              [{nivel: 3, pos:96}],
          '10503':              [{nivel: 3, pos:97}],
          '1050301':              [{nivel: 4, pos:98}],
          '1050302':              [{nivel: 4, pos:99}],
          '1050303':              [{nivel: 4, pos:100}],
          '1050304':              [{nivel: 4, pos:101}],
          '1050305':              [{nivel: 4, pos:102}],
          '1050306':              [{nivel: 4, pos:103}],
          '1050307':              [{nivel: 4, pos:104}],
          '10504':              [{nivel: 3, pos:105}],
          '106':              [{nivel: 2, pos:106}],
          '10601':              [{nivel: 3, pos:107}],
          '10602':              [{nivel: 3, pos:108}],
          '10603':              [{nivel: 3, pos:109}],
          '10604':              [{nivel: 3, pos:110}],
          '10605':              [{nivel: 3, pos:111}],
          '10606':              [{nivel: 3, pos:112}],
          '107':              [{nivel: 2, pos:113}],
          '10701':              [{nivel: 3, pos:114}],
          '1070101':              [{nivel: 4, pos:115}],
          '1070102':              [{nivel: 4, pos:116}],
          '1070103':              [{nivel: 4, pos:117}],
          '1070104':              [{nivel: 4, pos:118}],
          '1070105':              [{nivel: 4, pos:119}],
          '1070106':              [{nivel: 4, pos:120}],
          '1070107':              [{nivel: 4, pos:121}],
          '1070108':              [{nivel: 4, pos:122}],
          '10702':              [{nivel: 3, pos:123}],
          '1070201':              [{nivel: 4, pos:124}],
          '1070202':              [{nivel: 4, pos:125}],
          '1070203':              [{nivel: 4, pos:126}],
          '1070204':              [{nivel: 4, pos:127}],
          '1070205':              [{nivel: 4, pos:128}],
          '1070206':              [{nivel: 4, pos:129}],
          '1070207':              [{nivel: 4, pos:130}],
          '1070208':              [{nivel: 4, pos:131}],
          '10703':              [{nivel: 3, pos:132}],
          '1070301':              [{nivel: 4, pos:133}],
          '1070302':              [{nivel: 4, pos:134}],
          '1070303':              [{nivel: 4, pos:135}],
          '1070304':              [{nivel: 4, pos:136}],
          '1070305':              [{nivel: 4, pos:137}],
          '1070306':              [{nivel: 4, pos:138}],
          '10704':              [{nivel: 3, pos:139}],
          '1070401':              [{nivel: 4, pos:140}],
          '1070402':              [{nivel: 4, pos:141}],
          '1070403':              [{nivel: 4, pos:142}],
          '1070404':              [{nivel: 4, pos:143}],
          '1070405':              [{nivel: 4, pos:144}],
          '1070406':              [{nivel: 4, pos:145}],
          '108':              [{nivel: 2, pos:146}],
          '10801':              [{nivel: 3, pos:147}],
          '1080101':              [{nivel: 4, pos:148}],
          '1080102':              [{nivel: 4, pos:149}],
          '10802':              [{nivel: 3, pos:150}],
          '1080201':              [{nivel: 4, pos:151}],
          '1080202':              [{nivel: 4, pos:152}],
          '10803':              [{nivel: 3, pos:153}],
          '1080301':              [{nivel: 4, pos:154}],
          '1080302':              [{nivel: 4, pos:155}],
          '10804':              [{nivel: 3, pos:156}],
          '1080401':              [{nivel: 4, pos:157}],
          '1080402':              [{nivel: 4, pos:158}],
          '109':              [{nivel: 2, pos:159}],
          '10901':              [{nivel: 3, pos:160}],
          '1090101':              [{nivel: 4, pos:161}],
          '1090102':              [{nivel: 4, pos:162}],
          '10902':              [{nivel: 3, pos:163}],
          '1090201':              [{nivel: 4, pos:164}],
          '1090202':              [{nivel: 4, pos:165}],
          '10903':              [{nivel: 3, pos:166}],
          '1090301':              [{nivel: 4, pos:167}],
          '1090302':              [{nivel: 4, pos:168}],
          '10904':              [{nivel: 3, pos:169}],
          '1090401':              [{nivel: 4, pos:170}],
          '1090402':              [{nivel: 4, pos:171}],
          '110':              [{nivel: 2, pos:172}],
          '11001':              [{nivel: 3, pos:173}],
          '11002':              [{nivel: 3, pos:174}],
          '111':              [{nivel: 2, pos:175}],
          '11101':              [{nivel: 3, pos:176}],
          '1110101':              [{nivel: 4, pos:177}],
          '111010101':               [{nivel: 5, pos:178}],
          '111010102':              [{nivel: 5, pos:179}],
          '111010103':              [{nivel: 5, pos:180}],
          '111010104':              [{nivel: 5, pos:181}],
          '111010105':              [{nivel: 5, pos:182}],
          '1110102':              [{nivel: 4, pos:183}],
          '111010201':              [{nivel: 5, pos:184}],
          '111010202':              [{nivel: 5, pos:185}],
          '111010203':              [{nivel: 5, pos:186}],
          '111010204':              [{nivel: 5, pos:187}],
          '111010205':              [{nivel: 5, pos:188}],
          '1110103':              [{nivel: 4, pos:189}],
          '111010301':              [{nivel: 5, pos:190}],
          '111010302':              [{nivel: 5, pos:191}],
          '111010303':              [{nivel: 5, pos:192}],
          '111010304':              [{nivel: 5, pos:193}],
          '111010305':              [{nivel: 5, pos:194}],
          '111010306':              [{nivel: 5, pos:195}],
          '111010307':              [{nivel: 5, pos:196}],
          '111010308':              [{nivel: 5, pos:197}],
          '111010309':              [{nivel: 5, pos:198}],
          '111010310':              [{nivel: 5, pos:199}],
          '11102':              [{nivel: 3, pos:200}],
          '1110201':              [{nivel: 4, pos:201}],
          '111020101':              [{nivel: 5, pos:202}],
          '111020102':              [{nivel: 5, pos:203}],
          '111020103':              [{nivel: 5, pos:204}],
          '1110202':              [{nivel: 4, pos:205}],
          '2':              [{nivel: 1, pos:206}],
          '201':              [{nivel: 2, pos:207}],
          '20101':              [{nivel: 3, pos:208}],
          '2010101':              [{nivel: 4, pos:209}],
          '201010101':              [{nivel: 5, pos:210}],
          '201010102':              [{nivel: 5, pos:211}],
          '2010102':              [{nivel: 4, pos:212}],
          '201010201':              [{nivel: 5, pos:213}],
          '201010202':              [{nivel: 5, pos:214}],
          '20102':              [{nivel: 3, pos:215}],
          '2010201':              [{nivel: 4, pos:216}],
          '201020101':              [{nivel: 5, pos:217}],
          '201020102':              [{nivel: 5, pos:218}],
          '2010202':              [{nivel: 4, pos:219}],
          '201020201':              [{nivel: 5, pos:220}],
          '201020202':              [{nivel: 5, pos:221}],
          '20103':              [{nivel: 3, pos:222}],
          '202':              [{nivel: 2, pos:223}],
          '20201':              [{nivel: 3, pos:224}],
          '20202':              [{nivel: 3, pos:225}],
          '203':              [{nivel: 2, pos:226}],
          '20301':              [{nivel: 3, pos:227}],
          '20302':              [{nivel: 3, pos:228}],
          '204':              [{nivel: 2, pos:229}],
          '20401':              [{nivel: 3, pos:230}],
          '20402':              [{nivel: 3, pos:231}],
          '20403':              [{nivel: 3, pos:232}],
          '20404':              [{nivel: 3, pos:233}],
          '20405':              [{nivel: 3, pos:234}],
          '2040501':              [{nivel: 4, pos:235}],
          '2040502':              [{nivel: 4, pos:236}],
          '2040503':              [{nivel: 4, pos:237}],
          '20406':              [{nivel: 3, pos:238}],
          '2040601':              [{nivel: 4, pos:239}],
          '2040602':              [{nivel: 4, pos:240}],
          '2040603':              [{nivel: 4, pos:241}],
          '2040604':              [{nivel: 4, pos:242}],
          '20407':              [{nivel: 3, pos:243}],
          '2040701':              [{nivel: 4, pos:244}],
          '204070101':              [{nivel: 5, pos:245}],
          '204070102':              [{nivel: 5, pos:246}],
          '204070103':              [{nivel: 5, pos:247}],
          '204070104':              [{nivel: 5, pos:248}],
          '204070105':              [{nivel: 5, pos:249}],
          '2040702':              [{nivel: 4, pos:250}],
          '2040703':              [{nivel: 4, pos:251}],
          '2040704':              [{nivel: 4, pos:252}],
          '2040705':              [{nivel: 4, pos:253}],
          '2040706':              [{nivel: 4, pos:254}],
          '2040707':              [{nivel: 4, pos:255}],
          '2040708':              [{nivel: 4, pos:256}],
          '2040709':              [{nivel: 4, pos:257}],
          '2040710':              [{nivel: 4, pos:258}],
          '2040711':              [{nivel: 4, pos:259}],
          '2040712':              [{nivel: 4, pos:260}],
          '204071201':              [{nivel: 5, pos:261}],
          '204071202':              [{nivel: 5, pos:262}],
          '204071203':              [{nivel: 5, pos:263}],
          '2040713':              [{nivel: 4, pos:264}],
          '204071301':              [{nivel: 5, pos:265}],
          '204071302':              [{nivel: 5, pos:266}],
          '204071303':              [{nivel: 5, pos:267}],
          '204071304':              [{nivel: 5, pos:268}],
          '204071305':              [{nivel: 5, pos:269}],
          '2040714':              [{nivel: 4, pos:270}],
          '2040715':              [{nivel: 4, pos:271}],
          '205':              [{nivel: 2, pos:272}],
          '206':              [{nivel: 2, pos:273}],
          '20601':              [{nivel: 3, pos:274}],
          '2060101':              [{nivel: 4, pos:275}],
          '2060102':              [{nivel: 4, pos:276}],
          '2060103':              [{nivel: 4, pos:277}],
          '2060104':              [{nivel: 4, pos:278}],
          '2060105':              [{nivel: 4, pos:279}],
          '2060106':              [{nivel: 4, pos:280}],
          '2060107':              [{nivel: 4, pos:281}],
          '20602':              [{nivel: 3, pos:282}],
          '2060201':              [{nivel: 4, pos:283}],
          '2060202':              [{nivel: 4, pos:284}],
          '2060203':              [{nivel: 4, pos:285}],
          '2060204':              [{nivel: 4, pos:286}],
          '2060205':              [{nivel: 4, pos:287}],
          '3':              [{nivel: 1, pos:288}],
          '301':              [{nivel: 2, pos:289}],
          '30101':              [{nivel: 3, pos:290}],
          '3010101':              [{nivel: 4, pos:291}],
          '3010102':              [{nivel: 4, pos:292}],
          '301010201':              [{nivel: 5, pos:293}],
          '301010202':              [{nivel: 5, pos:294}],
          '3010103':              [{nivel: 4, pos:295}],
          '30102':              [{nivel: 3, pos:296}],
          '3010201':              [{nivel: 4, pos:297}],
          '3010202':              [{nivel: 4, pos:298}],
          '3010203':              [{nivel: 4, pos:299}],
          '30103':              [{nivel: 3, pos:300}],
          '30104':              [{nivel: 3, pos:301}],
          '30105':              [{nivel: 3, pos:302}],
          '30106':              [{nivel: 3, pos:303}],
          '30107':              [{nivel: 3, pos:304}],
          '302':              [{nivel: 2, pos:305}],
          '30201':              [{nivel: 3, pos:306}],
          '30202':              [{nivel: 3, pos:307}],
          '30203':              [{nivel: 3, pos:308}],
          '30204':              [{nivel: 3, pos:309}],
          '303':              [{nivel: 2, pos:310}],
          '30301':              [{nivel: 3, pos:311}],
          '3030101':              [{nivel: 4, pos:312}],
          '3030102':              [{nivel: 4, pos:313}],
          '30302':              [{nivel: 3, pos:314}],
          '30303':              [{nivel: 3, pos:315}],
          '3030301':              [{nivel: 4, pos:316}],
          '3030302':              [{nivel: 4, pos:317}],
          '30304':              [{nivel: 3, pos:318}],
          '30305':              [{nivel: 3, pos:319}],
          '3030501':              [{nivel: 4, pos:320}],
          '303050101':              [{nivel: 5, pos:321}],
          '303050102':              [{nivel: 5, pos:322}],
          '303050103':              [{nivel: 5, pos:323}],
          '303050104':              [{nivel: 5, pos:324}],
          '3030502':              [{nivel: 4, pos:325}],
          '303050201':              [{nivel: 5, pos:326}],
          '303050202':              [{nivel: 5, pos:327}],
          '303050203':              [{nivel: 5, pos:328}],
          '303050204':              [{nivel: 5, pos:329}],
          '30306':              [{nivel: 3, pos:330}],
          '30307':              [{nivel: 3, pos:331}],
          '3030701':              [{nivel: 4, pos:332}],
          '30308':              [{nivel: 3, pos:333}],
          '30309':              [{nivel: 3, pos:334}],
        }
        return idsBal[id] ?? undefined;
      case 'estados':
        const idsEst = {
          '401':              [{nivel: 1, pos:1}],
          '40101':              [{nivel: 2, pos:2}],
          '4010101':              [{nivel: 3, pos:3}],
          '4010102':              [{nivel: 3, pos:4}],
          '40102':              [{nivel: 2, pos:5}],
          '4010201':              [{nivel: 3, pos:6}],
          '4010202':              [{nivel: 3, pos:7}],
          '4010203':              [{nivel: 3, pos:8}],
          '40103':              [{nivel: 2, pos:9}],
          '40104':              [{nivel: 2, pos:10}],
          '4010401':              [{nivel: 3, pos:11}],
          '401040101':              [{nivel: 4, pos:12}],
          '401040102':              [{nivel: 4, pos:13}],
          '4010402':              [{nivel: 3, pos:14}],
          '401040201':              [{nivel: 4, pos:15}],
          '401040202':              [{nivel: 4, pos:16}],
          '401040203':              [{nivel: 4, pos:17}],
          '401040204':              [{nivel: 4, pos:18}],
          '401040205':              [{nivel: 4, pos:19}],
          '401040206':              [{nivel: 4, pos:20}],
          '401040207':              [{nivel: 4, pos:21}],
          '4010403':              [{nivel: 3, pos:22}],
          '401040301':              [{nivel: 4, pos:23}],
          '401040302':              [{nivel: 4, pos:24}],
          '40105':              [{nivel: 2, pos:25}],
          '4010501':              [{nivel: 3, pos:26}],
          '401050101':              [{nivel: 4, pos:27}],
          '401050102':              [{nivel: 4, pos:28}],
          '4010502':              [{nivel: 3, pos:29}],
          '401050201':              [{nivel: 4, pos:30}],
          '401050202':              [{nivel: 4, pos:31}],
          '401050203':              [{nivel: 4, pos:32}],
          '401050204':              [{nivel: 4, pos:33}],
          '401050205':              [{nivel: 4, pos:34}],
          '401050206':              [{nivel: 4, pos:35}],
          '401050207':              [{nivel: 4, pos:36}],
          '4010503':              [{nivel: 3, pos:37}],
          '401050301':              [{nivel: 4, pos:38}],
          '401050302':              [{nivel: 4, pos:39}],
          '40106':              [{nivel: 2, pos:40}],
          '4010601':              [{nivel: 3, pos:41}],
          '4010602':              [{nivel: 3, pos:42}],
          '4010603':              [{nivel: 3, pos:43}],
          '40107':              [{nivel: 2, pos:44}],
          '4010701':              [{nivel: 3, pos:45}],
          '4010702':              [{nivel: 3, pos:46}],
          '40108':              [{nivel: 2, pos:47}],
          '501':              [{nivel: 1, pos:48}],
          '50101':              [{nivel: 2, pos:49}],
          '50102':              [{nivel: 2, pos:50}],
          '50103':              [{nivel: 2, pos:51}],
          '50104':              [{nivel: 2, pos:52}],
          '50105':              [{nivel: 2, pos:53}],
          '50106':              [{nivel: 2, pos:54}],
          '5010601':              [{nivel: 3, pos:55}],
          '5010602':              [{nivel: 3, pos:56}],
          '50107':              [{nivel: 2, pos:57}],
          '402':              [{nivel: 1, pos:58}],
          '40201':              [{nivel: 2, pos:59}],
          '40202':              [{nivel: 2, pos:60}],
          '40203':              [{nivel: 2, pos:61}],
          'VT01':              [{nivel: 1, pos:62}],
          '502':              [{nivel: 2, pos:63}],
          '50201':              [{nivel: 3, pos:64}],
          '5020101':              [{nivel: 4, pos:65}],
          '502010101':              [{nivel: 5, pos:66}],
          '502010102':              [{nivel: 5, pos:67}],
          '502010103':              [{nivel: 5, pos:68}],
          '50202':              [{nivel: 3, pos:69}],
          '5020201':              [{nivel: 4, pos:70}],
          '5020202':              [{nivel: 4, pos:71}],
          '5020203':              [{nivel: 4, pos:72}],
          '5020204':              [{nivel: 4, pos:73}],
          '50203':              [{nivel: 3, pos:74}],
          'VT02':              [{nivel: 1, pos:75}],
          '403':              [{nivel: 2, pos:76}],
          '40301':              [{nivel: 3, pos:77}],
          '4030101':              [{nivel: 4, pos:78}],
          '403010101':              [{nivel: 5, pos:79}],
          '403010102':              [{nivel: 5, pos:80}],
          '403010103':              [{nivel: 5, pos:81}],
          '403010104':              [{nivel: 5, pos:82}],
          '403010105':              [{nivel: 5, pos:83}],
          '403010106':              [{nivel: 5, pos:84}],
          '4030102':              [{nivel: 4, pos:85}],
          '403010201':              [{nivel: 5, pos:86}],
          '403010202':              [{nivel: 5, pos:87}],
          '403010203':              [{nivel: 5, pos:88}],
          '403010204':              [{nivel: 5, pos:89}],
          '403010205':              [{nivel: 5, pos:90}],
          '403010206':              [{nivel: 5, pos:91}],
          '403010207':              [{nivel: 5, pos:92}],
          '4030103':              [{nivel: 4, pos:93}],
          '403010301':              [{nivel: 5, pos:94}],
          '403010302':              [{nivel: 5, pos:95}],
          '40302':              [{nivel: 3, pos:96}],
          '40303':              [{nivel: 3, pos:97}],
          '40304':              [{nivel: 3, pos:98}],
          '40305':              [{nivel: 3, pos:99}],
          '40306':              [{nivel: 3, pos:100}],
          '40307':              [{nivel: 3, pos:101}],
          '40308':              [{nivel: 3, pos:102}],
          '40309':              [{nivel: 3, pos:103}],
          '40310':              [{nivel: 3, pos:104}],
          '40311':              [{nivel: 3, pos:105}],
          '40312':              [{nivel: 3, pos:106}],
          '503':              [{nivel: 2, pos:107}],
          '50301':              [{nivel: 3, pos:108}],
          '50302':              [{nivel: 3, pos:109}],
          '50303':              [{nivel: 3, pos:110}],
          '50304':              [{nivel: 3, pos:111}],
          '50305':              [{nivel: 3, pos:112}],
          '50306':              [{nivel: 3, pos:113}],
          '404':              [{nivel: 2, pos:114}],
          '40401':              [{nivel: 3, pos:115}],
          '4040101':              [{nivel: 4, pos:116}],
          '4040102':              [{nivel: 4, pos:117}],
          '40402':              [{nivel: 3, pos:118}],
          '4040201':              [{nivel: 4, pos:119}],
          '4040202':              [{nivel: 4, pos:120}],
          '40403':              [{nivel: 3, pos:121}],
          '40404':              [{nivel: 3, pos:122}],
          '4040401':              [{nivel: 4, pos:123}],
          '4040402':              [{nivel: 4, pos:124}],
          '4040403':              [{nivel: 4, pos:125}],
          '40405':              [{nivel: 3, pos:126}],
          '40406':              [{nivel: 3, pos:127}],
          '40407':              [{nivel: 3, pos:128}],
          '40408':              [{nivel: 3, pos:129}],
          '405':              [{nivel: 2, pos:130}],
          '40501':              [{nivel: 3, pos:131}],
          '40502':              [{nivel: 3, pos:132}],
          '4050201':              [{nivel: 4, pos:133}],
          '4050202':              [{nivel: 4, pos:134}],
          '40503':              [{nivel: 3, pos:135}],
          '40504':              [{nivel: 3, pos:136}],
          '40505':              [{nivel: 3, pos:137}],
          '40506':              [{nivel: 3, pos:138}],
          '40507':              [{nivel: 3, pos:139}],
          '40508':              [{nivel: 3, pos:140}],
          '40509':              [{nivel: 3, pos:141}],
          '40510':              [{nivel: 3, pos:142}],
          '4051001':              [{nivel: 4, pos:143}],
          '4051002':              [{nivel: 4, pos:144}],
          '4051003':              [{nivel: 4, pos:145}],
          '4051004':              [{nivel: 4, pos:146}],
          '40511':              [{nivel: 3, pos:147}],
          '4051101':              [{nivel: 4, pos:148}],
          '4051102':              [{nivel: 4, pos:149}],
          '40512':              [{nivel: 3, pos:150}],
          '40513':              [{nivel: 3, pos:151}],
          '40514':              [{nivel: 3, pos:152}],
          '40515':              [{nivel: 3, pos:153}],
          '40516':              [{nivel: 3, pos:154}],
          '40517':              [{nivel: 3, pos:155}],
          '40518':              [{nivel: 3, pos:156}],
          '40519':              [{nivel: 3, pos:157}],
          '4051901':              [{nivel: 4, pos:158}],
          '4051902':              [{nivel: 4, pos:159}],
          '4051903':              [{nivel: 4, pos:160}],
          '4051904':              [{nivel: 4, pos:161}],
          '4051905':              [{nivel: 4, pos:162}],
          '40520':              [{nivel: 3, pos:163}],
          '40521':              [{nivel: 3, pos:164}],
          '40522':              [{nivel: 3, pos:165}],
          '40523':              [{nivel: 3, pos:166}],
          '40524':              [{nivel: 3, pos:167}],
          '40525':              [{nivel: 3, pos:168}],
          '40526':              [{nivel: 3, pos:169}],
          '40527':              [{nivel: 3, pos:170}],
          '40528':              [{nivel: 3, pos:171}],
          '40529':              [{nivel: 3, pos:172}],
          '40530':              [{nivel: 3, pos:173}],
          '40531':              [{nivel: 3, pos:174}],
          '504':              [{nivel: 2, pos:175}],
          '50401':              [{nivel: 3, pos:176}],
          '50402':              [{nivel: 3, pos:177}],
          '5040201':              [{nivel: 4, pos:178}],
          '5040202':              [{nivel: 4, pos:179}],
          '504020201':              [{nivel: 5, pos:180}],
          '504020202':              [{nivel: 5, pos:181}],
          '504020203':              [{nivel: 5, pos:182}],
          '5040203':              [{nivel: 4, pos:183}],
          '504020301':              [{nivel: 5, pos:184}],
          '504020302':              [{nivel: 5, pos:185}],
          '50403':              [{nivel: 3, pos:186}],
          '5040301':              [{nivel: 4, pos:187}],
          '5040302':              [{nivel: 4, pos:188}],
          '5040303':              [{nivel: 4, pos:189}],
          '50404':              [{nivel: 3, pos:190}],
          '50405':              [{nivel: 3, pos:191}],
          '50406':              [{nivel: 3, pos:192}],
          '50407':              [{nivel: 3, pos:193}],
          '50408':              [{nivel: 3, pos:194}],
          '50409':              [{nivel: 3, pos:195}],
          '50410':              [{nivel: 3, pos:196}],
          '50411':              [{nivel: 3, pos:197}],
          '50412':              [{nivel: 3, pos:198}],
          '50413':              [{nivel: 3, pos:199}],
          '50414':              [{nivel: 3, pos:200}],
          'VT03':              [{nivel: 1, pos:201}],
          '406':              [{nivel: 2, pos:202}],
          '40601':              [{nivel: 3, pos:203}],
          '4060101':              [{nivel: 4, pos:204}],
          '406010101':              [{nivel: 5, pos:205}],
          '406010102':              [{nivel: 5, pos:206}],
          '4060102':              [{nivel: 4, pos:207}],
          '406010201':              [{nivel: 5, pos:208}],
          '406010202':              [{nivel: 5, pos:209}],
          '4060103':              [{nivel: 4, pos:210}],
          '406010301':              [{nivel: 5, pos:211}],
          '406010302':              [{nivel: 5, pos:212}],
          '40602':              [{nivel: 3, pos:213}],
          'VT04':              [{nivel: 1, pos:214}],
          '407':              [{nivel: 2, pos:215}],
          '40701':              [{nivel: 3, pos:216}],
          '40702':              [{nivel: 3, pos:217}],
          'VT05':              [{nivel: 1, pos:218}],
        }
        return idsEst[id] ?? undefined
    }
  }
}

export class obtenerEstructura{
  static idsCuentas(idPlantilla: string){
    switch(idPlantilla){
      default:
        const idsEstructura = {
          "Activo": '1',
          "Pasivo": '2',
          "Patrimonio": '3'
        }
        return idsEstructura;
    }
  }
}

export class obtenerSegmentos{
  static idsCuentasP4(id: string){
    const ids = {
      '104':              [{nivel: 1, pos:1}], //SEGMENTO 1
      '10401':              [{nivel: 2, pos:2}],
      '1040101':              [{nivel: 3, pos:3}],
      '104010101':              [{nivel: 4, pos:4}],
      '104010102':              [{nivel: 4, pos:5}],
      '104010103':              [{nivel: 4, pos:6}],
      '104010104':              [{nivel: 4, pos:7}],
      '104010105':              [{nivel: 4, pos:8}],
      '104010106':              [{nivel: 4, pos:9}],
      '1040102':              [{nivel: 3, pos:10}],
      '104010201':              [{nivel: 4, pos:11}],
      '104010202':              [{nivel: 4, pos:12}],
      '104010203':              [{nivel: 4, pos:13}],
      '104010204':              [{nivel: 4, pos:14}],
      '104010205':              [{nivel: 4, pos:15}],
      '104010206':              [{nivel: 4, pos:16}],
      '104010207':              [{nivel: 4, pos:17}],
      '1040103':              [{nivel: 3, pos:18}],
      '104010301':              [{nivel: 4, pos:19}],
      '104010302':              [{nivel: 4, pos:20}],
      '10402':              [{nivel: 2, pos:21}],
      '1040201':              [{nivel: 3, pos:22}],
      '104020101':              [{nivel: 4, pos:23}],
      '104020102':              [{nivel: 4, pos:24}],
      '104020103':              [{nivel: 4, pos:25}],
      '104020104':              [{nivel: 4, pos:26}],
      '104020105':              [{nivel: 4, pos:27}],
      '104020106':              [{nivel: 4, pos:28}],
      '1040202':              [{nivel: 3, pos:29}],
      '104020201':              [{nivel: 4, pos:30}],
      '104020202':              [{nivel: 4, pos:31}],
      '104020203':              [{nivel: 4, pos:32}],
      '104020204':              [{nivel: 4, pos:33}],
      '104020205':              [{nivel: 4, pos:34}],
      '104020206':              [{nivel: 4, pos:35}],
      '104020207':              [{nivel: 4, pos:36}],
      '1040203':              [{nivel: 3, pos:37}],
      '104020301':              [{nivel: 4, pos:38}],
      '104020302':              [{nivel: 4, pos:39}],
      '10403':              [{nivel: 2, pos:40}],
      '1040301':              [{nivel: 3, pos:41}],
      '104030101':              [{nivel: 4, pos:42}],
      '104030102':              [{nivel: 4, pos:43}],
      '104030103':              [{nivel: 4, pos:44}],
      '1040302':              [{nivel: 3, pos:45}],
      '104030201':              [{nivel: 4, pos:46}],
      '104030202':              [{nivel: 4, pos:47}],
      '104030203':              [{nivel: 4, pos:48}],
      '104030204':              [{nivel: 4, pos:49}],
      '201':              [{nivel: 1, pos:50}], //SEGMENTO 2
      '20101':              [{nivel: 2, pos:51}],
      '2010101':              [{nivel: 3, pos:52}],
      '201010101':              [{nivel: 4, pos:53}],
      '201010102':              [{nivel: 4, pos:54}],
      '2010102':              [{nivel: 3, pos:55}],
      '201010201':              [{nivel: 4, pos:56}],
      '201010202':              [{nivel: 4, pos:57}],
      '20102':              [{nivel: 2, pos:58}],
      '2010201':              [{nivel: 3, pos:59}],
      '201020101':              [{nivel: 4, pos:60}],
      '201020102':              [{nivel: 4, pos:61}],
      '2010202':              [{nivel: 3, pos:62}],
      '201020201':              [{nivel: 4, pos:63}],
      '201020202':              [{nivel: 4, pos:64}],
      '20103':              [{nivel: 2, pos:65}],
      '504':              [{nivel: 1, pos:66}], //SEGMENTO 3
      '50401':              [{nivel: 2, pos:67}],
      '50402':              [{nivel: 2, pos:68}],
      '5040201':              [{nivel: 3, pos:69}],
      '5040202':              [{nivel: 3, pos:70}],
      '504020201':              [{nivel: 4, pos:71}],
      '504020202':              [{nivel: 4, pos:72}],
      '504020203':              [{nivel: 4, pos:73}],
      '5040203':              [{nivel: 3, pos:74}],
      '504020301':              [{nivel: 4, pos:75}],
      '504020302':              [{nivel: 4, pos:76}],
      '50403':              [{nivel: 2, pos:77}],
      '5040301':              [{nivel: 3, pos:78}],
      '5040302':              [{nivel: 3, pos:79}],
      '5040303':              [{nivel: 3, pos:80}],
      '50404':              [{nivel: 2, pos:81}],
      '50405':              [{nivel: 2, pos:82}],
      '50406':              [{nivel: 2, pos:83}],
      '50407':              [{nivel: 2, pos:84}],
      '50408':              [{nivel: 2, pos:85}],
      '50409':              [{nivel: 2, pos:86}],
      '50410':              [{nivel: 2, pos:87}],
      '50411':              [{nivel: 2, pos:88}],
      '50412':              [{nivel: 2, pos:89}],
      '50413':              [{nivel: 2, pos:90}],
      '50414':              [{nivel: 2, pos:91}],
    }
    return ids[id] ?? undefined
    
  }
  static idsSegmentos(plantilla: number){
    var ids =[];
    switch(plantilla){
      case 4: 
        ids = [{id:'104', movimiento: false}, {id: '201', movimiento: false}, {id: '504', movimiento: true}];
        return ids;
      default:
        return ids;
    } 
  }
}

export class obtenerVariables{
  static variables(plantilla: number){
    var vars = {};
    switch(plantilla){
      case 4: 
        vars = {
          3: ['VT01', 'VT02', 'VT03', 'VT04', 'VT05']
        }
        return vars;
      default: return '';
    }
  }
}

export class coloresSemaforos{
  static color(txt: string){
    let c = '';
    switch(txt){
      case 'v+': c = '#72d54a';
        break;
      case 'v-': c = '#9ae600';
        break;
      case 'a+': c = '#ffd100';
        break;
      case 'a-': c = '#ffdf20';
        break;
      case 'r+': c = '#ff495c';
        break;
      case 'r-': c = '#ff6467';
        break;
    }
    return c;
  }
}